(function () {
  function init(root) {
    if (root.dataset.fczReady === '1') return;
    root.dataset.fczReady = '1';

    var viewport = root.querySelector('[data-fcz-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fcz-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fcz-dot]'));
    if (!viewport || slides.length < 2) return;

    var delay = parseInt(root.getAttribute('data-fcz-delay'), 10) || 0;
    var current = 0;
    var timer = null;
    var paused = false;

    function scrollToIndex(i, smooth) {
      var slide = slides[i];
      if (!slide) return;
      var left = slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
      viewport.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    function setActive(i) {
      current = i;
      dots.forEach(function (d, n) {
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }

    function nearestIndex() {
      var center = viewport.scrollLeft + viewport.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, n) {
        var mid = s.offsetLeft + s.clientWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = n; }
      });
      return best;
    }

    var scrollTick;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTick);
      scrollTick = setTimeout(function () { setActive(nearestIndex()); }, 90);
    }, { passive: true });

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        setActive(n);
        scrollToIndex(n);
        restart();
      });
    });

    function advance() {
      var next = (current + 1) % slides.length;
      setActive(next);
      scrollToIndex(next);
    }

    function start() {
      if (!delay || paused) return;
      stop();
      timer = setInterval(advance, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    viewport.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      delay = 0;
    }

    setActive(0);
    scrollToIndex(0, false);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-fcz-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
